export const actionTypes = {
  VERIFY_TOKEN_REQUEST: 'VERIFY_TOKEN_REQUEST',
  VERIFY_TOKEN_SUCCESS: 'VERIFY_TOKEN_SUCCESS',
  VERIFY_TOKEN_FAILURE: 'VERIFY_TOKEN_FAILURE',

  CREATE_PASSWORD_REQUEST: 'CREATE_PASSWORD_REQUEST',
  CREATE_PASSWORD_SUCCESS: 'CREATE_PASSWORD_SUCCESS',
  CREATE_PASSWORD_FAILURE: 'CREATE_PASSWORD_FAILURE',
};
